import { Component, Input, OnInit } from '@angular/core';
import { Permission } from '@shared/types/permission';
import { AddNextStepComponent } from '../add-next-step/add-next-step.component';
import { PopoverController } from '@ionic/angular';
import { Context } from '@shared/types/context';
import { Observable } from 'rxjs';
import { LoadingState } from '@shared/types/loading-state';
import { NextStep } from '@shared/models/next-step';
import { NextStepsService } from '@features/next-steps/services/next-steps.service';
import { Opportunity } from '@shared/models/opportunity';
import { OpportunitiesService } from '@features/opportunities/services/opportunities.service';
import { Lead } from '@shared/models/lead';
import { LeadsService } from '@features/leads/services/leads.service';

@Component({
  selector: 'app-next-step-details',
  templateUrl: './next-step-details.component.html',
  styleUrls: ['./next-step-details.component.scss'],
  standalone: false,
})
export class NextStepDetailsComponent implements OnInit {
  @Input() leadId?: number;
  @Input() opportunityId?: number;
  @Input() groupId?: string;
  @Input() permissions: Permission[];
  @Input() context: Context;

  nextStep$: Observable<NextStep | undefined>;
  nextStepLoadingState$: Observable<LoadingState | undefined>;
  lead$: Observable<Lead | undefined>;
  opportunity$: Observable<Opportunity | undefined>;

  constructor(
    private popoverController: PopoverController,
    private nextStepsService: NextStepsService,
    private opportunitiesService: OpportunitiesService,
    private leadsService: LeadsService,
  ) {}

  ngOnInit(): void {
    this.nextStep$ = this.nextStepsService.getNextStep(this.leadId, this.groupId, this.opportunityId);
    this.nextStepLoadingState$ = this.nextStepsService.getNextStepsLoading();
    if (this.opportunityId) {
      this.opportunity$ = this.opportunitiesService.getOpportunityById(this.opportunityId);
    }
    if (this.leadId) {
      this.lead$ = this.leadsService.getLeadById(this.leadId);
    }
  }

  async presentNextStepDetailsPopover(event: any) {
    const popover = await this.popoverController.create({
      component: AddNextStepComponent,
      componentProps: {
        groupId: this.groupId,
        leadId: this.leadId,
        opportunityId: this.opportunityId,
      },
      event: event,
      alignment: 'start',
      side: 'right',
      size: 'auto',
      cssClass: 'add-next-step-popover',
      id: 'add-next-step-popover',
      dismissOnSelect: false,
    });
    return await popover.present();
  }
}
